import App from './App';
import Raven from 'raven-js';
const trackCacheStatus = (name, timing) => {
  const fetchStart = timing.fetchStart;
  const responseEnd = timing.responseEnd;
  Raven.setExtraContext({
    [`warm-${name}`]: responseEnd - fetchStart < 100
  });
};
const trackDLB = () => {
  Raven.setExtraContext({
    'using-dlb': true
  });
  window.performance.getEntries().forEach(t => {
    if (t.initiatorType === 'script' && /reporting-dlb/.test(t.name)) {
      trackCacheStatus('dlb', t);
    } else if (/knowledge-content-ui\/static-[\d.]+\/project.js/.test(t.name)) {
      trackCacheStatus('project', t);
    }
  });
};
new App().start();
trackDLB();